import { render, staticRenderFns } from "./shipping_record_detail.vue?vue&type=template&id=3bd88606&scoped=true&"
import script from "./shipping_record_detail.vue?vue&type=script&lang=js&"
export * from "./shipping_record_detail.vue?vue&type=script&lang=js&"
import style0 from "./shipping_record_detail.vue?vue&type=style&index=0&id=3bd88606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd88606",
  null
  
)

export default component.exports